import React from "react";
import "./FeatureSection.css";
import { motion } from "framer-motion";

const FeatureSection = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.3 }}
    >
      <section className="solutions-section">
        <div className="solutions-container">

          <div className="solutions-header">
            <p className="solutions-label">OUR SOLUTIONS</p>
            <h2>
              Explore our flagship platforms delivering real-world impact
              across transport, safety, and infrastructure.
            </h2>
          </div>

          <div className="solutions-grid">

            <a 
              href="/solutions/spacetime-city-twin" 
              className="solution-card"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <div className="solution-image blue"></div>
              <div className="solution-content">
                <h3>Spacetime CityTwin™ →</h3>
                <p>AI-powered urban mobility twin</p>
                <p>
                  Predicts and optimises transport patterns for greener,
                  safer mobility.
                </p>
              </div>
            </a>

            <a 
              href="/solutions/spacetime-safe-city" 
              className="solution-card"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <div className="solution-image red"></div>
              <div className="solution-content">
                <h3>Spacetime SafeCity™ →</h3>
                <p>AI for public safety and risk anticipation</p>
                <p>
                  Forecasts incidents and supports proactive emergency response.
                </p>
              </div>
            </a>

            <a 
              href="/solutions/spacetime-infra-plan" 
              className="solution-card"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <div className="solution-image green"></div>
              <div className="solution-content">
                <h3>Spacetime InfraPlan™ →</h3>
                <p>Infrastructure and renewable planning intelligence</p>
                <p>
                  Guides equitable, sustainable infrastructure and energy deployment.
                </p>
              </div>
            </a>

          </div>
        </div>
      </section>
    </motion.section>
  );
};

export default FeatureSection;